<div class="bg-bg-surface-default p-3">
  <div
    class="mx-auto flex max-w-[1440px] items-center gap-3"
    [class]="containerStyleClass">
    <app-button
      theme="transparent"
      class="w-max"
      styleClass="!px-0 !pr-2.5"
      (click)="location.back()">
      <div class="flex h-8 w-8 items-center justify-center">
        <ic-arrow-left-outline class="text-icon-subtle block h-5 w-5" />
      </div>
      <span
        class="text-text-default font-medium"
        [class]="backTitleStyleClass">
        {{ backTitle }}
      </span>
    </app-button>
    <div class="grow">
      <ic-ax-full class="mx-auto block h-6" />
    </div>
    <div class="flex w-40 justify-end">
      <app-button
        styleClass="!h-8"
        theme="outline"
        [icon]="true"
        (click)="globalService.toggleTheme()">
        <ic-sun-outline class="text-icon-subtle block h-5 w-5" />
      </app-button>
    </div>
  </div>
</div>
